import { manterNaTriagem } from './acaoTriagem';

/**
 * O MESMO Manter da Criação e das triagens de fluxo (`manter_em`): a
 * justificativa vira Nota na timeline PRIMEIRO (sem nota gravada, não pula) e
 * depois todos os itens do pedido ganham `manter_em = agora`, o que manda o
 * pedido para o fim da fila (`posicaoNaFila`). Desde 29/10/2026 numa ida e numa
 * transação (`fn_triagem_manter`).
 */
export async function manterPedidoNoFim({ titulo, pedido, justificativa, prd, coluna }: {
  titulo: string;
  pedido: { pedido_id: string; numero_pedido: string; cliente_id: string | null; itens: { item_id: string }[] };
  justificativa: string;
  prd?: string;
  /** A fila de onde o pedido desce; a linha que já saiu dela não é mexida. */
  coluna?: string | null;
}): Promise<{ numeroPedido: string }> {
  await manterNaTriagem({
    pedidoId: pedido.pedido_id,
    itens: pedido.itens.map((i) => i.item_id),
    coluna: coluna ?? null,
    nota: `🕐 ${titulo} — passado para o fim da fila: ${justificativa}${prd ? ` (PRD ${prd})` : ''}`,
  });
  return { numeroPedido: pedido.numero_pedido };
}
